import { RESET_POINT_OF_SALE_STATE } from '@dynameat/views/pointOfSale/mutationTypes';
import { FrontPriceList } from './models';
import * as MutationTypes from './mutationTypes';

const frontPriceListSuccess = (state, frontPriceList) => {
  state.frontPriceList = frontPriceList;
};

const applyChanges = (state, priceChanges) => {
  if (state.frontPriceList instanceof FrontPriceList) {
    priceChanges.forEach((change) => state.frontPriceList.editPrice(change));
  }
};

const resetData = (state) => {
  state.frontPriceList = null;
};

const noAction = () => {
};

export const mutations = {
  [MutationTypes.FRONT_PRICE_LIST_SUCCESS]: frontPriceListSuccess,
  [MutationTypes.UPDATE_FRONT_PRICE_LIST_SUCCESS]: noAction,
  [MutationTypes.APPLY_FRONT_PRICE_LIST_CHANGES]: applyChanges,
  [RESET_POINT_OF_SALE_STATE]: resetData,
};
